// Models
import { CopilotExtensions } from "./CopilotExtensions";
import { MarsPlannerCopilotPropertiesExtensions } from "./MarsPlannerCopilotPropertiesExtensions";
import { MarsPlannerLoopDetailsExtensions } from "./MarsPlannerLoopDetailsExtensions";
// Utilities
import isEqual from "lodash/isEqual";
import mergeWith from "lodash/mergeWith";
import { getDiff } from "@ms/uno-utilities/lib/local/ObjectUtilities";
// Constants
import { TaskExtensionProperties } from "@ms/uno-constants/lib/local/TaskExtensionProperties";
/**
 * Internal properties (extension fields) of a task
 */ export class TaskInternalProperties {
    toGraphSerializable() {
        const result = {};
        if (this.copilot) {
            try {
                result[TaskExtensionProperties.copilot] = JSON.stringify(this.copilot);
            } catch (error) {
                throw new Error("Error while serializing copilot extensions: " + error);
            }
        }
        if (this.mars_planner_microsoft_CopilotProperties) {
            try {
                result[TaskExtensionProperties.mars_planner_microsoft_CopilotProperties] = JSON.stringify(this.mars_planner_microsoft_CopilotProperties);
            } catch (error) {
                throw new Error("Error while serializing copilot properties extensions: " + error);
            }
        }
        if (this.mars_planner_microsoft_LoopDetails) {
            try {
                result[TaskExtensionProperties.mars_planner_microsoft_LoopDetails] = JSON.stringify(this.mars_planner_microsoft_LoopDetails);
            } catch (error) {
                throw new Error("Error while serializing loop extensions: " + error);
            }
        }
        return result;
    }
    static fromResource(resource) {
        let copilotExtensions = {};
        let copilotPropertiesExtensions = {};
        let loopDetails = {};
        if (resource[TaskExtensionProperties.copilot]) {
            try {
                const copilotExtensionData = JSON.parse(resource[TaskExtensionProperties.copilot]);
                copilotExtensions = new CopilotExtensions(copilotExtensionData.loopPageUrl, copilotExtensionData.id, copilotExtensionData.workflowSubmitTimeStamp, copilotExtensionData.isAiTask);
            } catch (error) {
                throw new Error("Error while deserializing copilot extensions: " + error);
            }
        }
        if (resource[TaskExtensionProperties.mars_planner_microsoft_CopilotProperties]) {
            try {
                const copilotExtensionData = JSON.parse(resource[TaskExtensionProperties.mars_planner_microsoft_CopilotProperties]);
                copilotPropertiesExtensions = new MarsPlannerCopilotPropertiesExtensions(copilotExtensionData.copilotWorkflowState, copilotExtensionData.copilotActivityTimestamp, copilotExtensionData.reason);
            } catch (error) {
                throw new Error("Error while deserializing copilot properties extensions: " + error);
            }
        }
        if (resource[TaskExtensionProperties.mars_planner_microsoft_LoopDetails]) {
            try {
                const loopDetailsData = JSON.parse(resource[TaskExtensionProperties.mars_planner_microsoft_LoopDetails]);
                loopDetails = new MarsPlannerLoopDetailsExtensions(loopDetailsData.pageId, loopDetailsData.loopPageShareUrl);
            } catch (error) {
                throw new Error("Error while deserializing loop extensions: " + error);
            }
        }
        return new TaskInternalProperties(copilotExtensions, copilotPropertiesExtensions, loopDetails);
    }
    getDiff(target) {
        const getDiffCustomizer = (source, target, key)=>{
            if (key === TaskExtensionProperties.copilot || key === TaskExtensionProperties.mars_planner_microsoft_CopilotProperties || key === TaskExtensionProperties.mars_planner_microsoft_LoopDetails) {
                if (!isEqual(source, target)) {
                    return target;
                } else {
                    return {};
                }
            }
        };
        return getDiff(this, target, getDiffCustomizer);
    }
    applyDiffs(...diff) {
        const mergeCustomizer = (source, target, key)=>{
            if (key === TaskExtensionProperties.copilot || key === TaskExtensionProperties.mars_planner_microsoft_CopilotProperties || key === TaskExtensionProperties.mars_planner_microsoft_LoopDetails) {
                return target ?? source;
            }
        };
        if (diff.length > 0) {
            return mergeWith(this.getClone(), ...diff, mergeCustomizer);
        }
        return this;
    }
    getClone() {
        return new TaskInternalProperties(this.copilot, this.mars_planner_microsoft_CopilotProperties, this.mars_planner_microsoft_LoopDetails);
    }
    constructor(copilot, mars_planner_microsoft_CopilotProperties, mars_planner_microsoft_LoopDetails){
        this.copilot = copilot;
        this.mars_planner_microsoft_CopilotProperties = mars_planner_microsoft_CopilotProperties;
        this.mars_planner_microsoft_LoopDetails = mars_planner_microsoft_LoopDetails;
        if (copilot) {
            this.copilot = copilot;
        }
        if (mars_planner_microsoft_CopilotProperties) {
            this.mars_planner_microsoft_CopilotProperties = mars_planner_microsoft_CopilotProperties;
        }
        if (mars_planner_microsoft_LoopDetails) {
            this.mars_planner_microsoft_LoopDetails = mars_planner_microsoft_LoopDetails;
        }
    }
}
